import { render } from "./SellerCard.vue?vue&type=template&id=d248b6b8&ts=true&lang=pug"
import script from "./SellerCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SellerCard.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__